export default __webpack_public_path__ + "static/media/logol.618ab810.png";